/**
 * Customer Fleet Overview layout route — eagerly registers the file route and
 * its `beforeLoad` auth guard; the page component and its atom/RPC imports are
 * deferred to `dashboard.lazy.tsx` so they load only with this route, never in
 * the always-loaded `main` chunk (CLA-645).
 *
 * The guard redirects a signed-out visitor to the brand login BEFORE the route
 * renders or any authed atom fires — so a logged-out `/clawinstall/dashboard`
 * lands on `/clawinstall/login` (via {@link requireAuth}'s host-aware
 * resolution) instead of throwing into the router error boundary. Because this
 * is the dashboard *layout* route, the guard runs ahead of every child screen
 * (`dashboard/index`, `dashboard/billing`, `dashboard/agents/*`), covering the
 * whole authenticated customer area. Mirrors
 * `flirtmachine/_authenticated.tsx`.
 *
 * IMPORTANT: Do NOT wrap requireAuth in Effect — TanStack redirects must be
 * thrown directly, not wrapped in Effect which turns them into FiberFailures.
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";

import { requireAuth } from "~/lib/server-auth.ts";

export const Route = createFileRoute("/clawinstall/dashboard")({
  // oxlint-disable-next-line eslint-js/no-restricted-syntax -- TanStack redirects require async/await, not Effect
  beforeLoad: async () => {
    // oxlint-disable-next-line eslint-js/no-restricted-syntax -- TanStack redirects require async/await, not Effect
    const auth = await requireAuth();
    return { auth };
  },
});
